// Can be accessed at locale.t('personStore.<key>')

export default {}
